module.exports = __webpack_public_path__ + "static/media/gallo_big.2ef93f7e.png";